import React, { ReactNode } from 'react'
import { TooltipView } from './TooltipView'
import { useTooltip } from './useTooltip'

export const Tooltip = ({ text, style = {}, children }: { text: string, style?: object, children: ReactNode }): JSX.Element => {
  return (
    <TooltipView {...useTooltip({ text })} style={style}>
      {children}
    </TooltipView>
  )
}
